export const projectsData = [
  {
    id: 1,
    name: 'Forest Essentials',
    description: 'Luxury skincare ritual storytelling.',
    year: '2025',
    slug: 'forest-essentials',
    image: 'linear-gradient(135deg, rgba(255, 182, 217, 0.92), rgba(248, 224, 235, 0.75))',
    accent: '#ff6ba9',
    heroBackground: '#ffffff',
    industry: 'Luxury Skincare / Beauty',
    services: ['Digital Luxury Storytelling', 'Moodboarding', 'Concept Video', 'Brand Narrative'],
    info: 'Forest Essentials is a luxury Ayurvedic brand that repositions skincare as sacred care. This project explored how storytelling, inspired by goddess archetypes, could elevate self-care into a soulful ritual. The outcome was a moodboard and a carefully assembled concept video, composed from AI-generated fragments and curated visuals, designed to embody serenity, ritual, and cultural elegance.',
    quote: 'They say the ancient goddesses bathed in sandalwood and river light.',

    // Content sections configuration
    sections: {
      // Custom project-specific images (shown before default sections)
      customImages: [
        { src: '/Projects/intro-forest.png', alt: 'Forest Essentials intro' }
      ],

      // Highlights section
      highlights: {
        enabled: true,
        cards: [
          {
            title: 'Crafting consistency from AI fragments',
            text: 'Working with Sora meant navigating unpredictability — every prompt could lead to visuals that broke the tone. The challenge was not in creating abundance, but in maintaining restraint. Through careful curation, sequencing, and prompt refinement, the final story held together with one voice: calm, immersive, sacred.'
          },
          {
            title: 'Telling a story without words',
            text: 'The video uses no narration, no slogans, no product shots. Instead, meaning is carried by water, jasmine, light, and silence. This decision was intentional — to show that luxury storytelling can be emotional and memorable even in absence of explanation.'
          }
        ]
      },

      // Moodboard section
      moodboard: {
        enabled: true,
        type: 'video',
        src: '/forest essentials.mp4'
      },

      // Promo/Campaign section
      promo: {
        enabled: true,
        label: 'AI-Generated Campaign',
        title: 'Forest Essentials - A Sacred Ritual',
        subtitle: 'Crafted entirely with AI, this promotional intro explores how technology can carry emotion, atmosphere, and brand essence without losing the soul of luxury storytelling.',
        videoSrc: '/DLS - forest essentials.mp4',
        caption: 'Every frame, transition, and moment of stillness was designed to mirror the brand\'s philosophy - rooted in nature, refined through ritual, and experienced with reverence.'
      },

      // Overview section
      overview: {
        credits: 'Surmayee Umathe - Concept, Script, Visual Direction, Video Assembly',
        capabilities: ['Storytelling', 'Concept Development', 'Moodboarding', 'AI Video Direction', 'Brand Narrative'],
        deliverables: ['Moodboard', 'Concept Video', 'Brand Narrative']
      }
    }
  },
  {
    id: 2,
    name: 'Mii Collections',
    description: 'Luxury retail concept for a Franco-Indian fashion house.',
    year: '2025',
    slug: 'mii-collections',
    image: 'linear-gradient(135deg, rgba(181, 168, 255, 0.35), rgba(233, 229, 255, 0.35))',
    accent: '#a68bff',
    heroBackground: '#ffffff',
    heroBorderColor: 'rgba(29, 20, 37, 0.18)',
    industry: 'Fashion / Luxury Retail Design',
    services: ['Visual Merchandising', 'Retail Strategy', 'Spatial Design', 'Sensory Storytelling'],
    info: 'Mii Collections reimagines a Franco-Indian fashion house by fusing French refinement with Indian craftsmanship. The project translated their digital sensibility into a tactile retail environment, choreographing spatial storytelling, sensory cues, and slow-luxury rituals so the boutique feels like a cultural experience instead of a store.',
    quote: 'Where Mediterranean ease meets Indian craft, a boutique becomes a quiet journey.',

    // Content sections configuration
    sections: {
      // Custom project-specific images
      customImages: [
        { src: '/Projects/mii collection/Intro Page.png', alt: 'Mii Collections intro page layout' },
        {
          src: '/Projects/mii collection/windowdisplayandmoodboard.png',
          alt: 'Mii Collections window display and moodboard',
          caption: 'A shared foundation that sparked my own interpretation of space, material, and mood within the boutique interior.'
        }
      ],

      // Highlights section (horizontal scrollable)
      highlights: {
        enabled: true,
        scrollable: true,
        cards: [
          {
            title: 'Designing for all senses',
            text: 'The floor plan emphasized sensory storytelling: soft ocean depths, a tactile aesthetic, fragrances, natural daylight through vintage stained glass, and textile contrasts of pebble-and-sand flooring. These layers transformed shopping into an immersive luxury experience.'
          },
          {
            title: 'A boutique as cultural bridge',
            text: 'French-Mediterranean design cues met Indian artisanal heritage. A central window display fused tweed creativity, while antique textile displays met contemporary visual purity - inviting customers into a cross-cultural dialogue where East and West, tradition and modernity, meet seamlessly.',
            align: 'right'
          },
          {
            title: 'Window scheme as a narrative anchor',
            text: 'Inspired by La Piscine\'s poetic art, I set it as a single foundation. I call it the complete point of inspiration - adding my own creative points, setting and interiors to maintain the collection\'s cultural story while also showing the visual heritage.',
            small: true
          }
        ]
      },

      // Full-width images section
      fullWidthImages: [
        { src: '/Projects/mii collection/Store Moodboard.png', alt: 'Mii Collections store moodboard' },
        { src: '/Projects/mii collection/Elements.png', alt: 'Mii Collections design elements' },
        { src: '/Projects/mii collection/Concept Board.png', alt: 'Mii Collections concept board' },
        { src: '/Projects/mii collection/Floor Planning.png', alt: 'Mii Collections floor planning' }
      ],

      // Moodboard section (disabled for this project)
      moodboard: {
        enabled: false
      },

      // Promo section (disabled for this project)
      promo: {
        enabled: false
      },

      // Overview section
      overview: {
        credits: 'Surmayee Umathe - Concept, Floor Plan, Window Scheme (Group Work)',
        capabilities: ['Visual Merchandising', 'Retail Design', 'Brand Storytelling', 'Consumer Journey Mapping'],
        deliverables: ['Immersive Window Concept', 'Moodboard & Concept Direction', 'Spatial Floor Plan', 'Consumer Journey Blueprint']
      }
    }
  },
  {
    id: 3,
    name: 'Luxury Retail Service',
    description: 'Will be unlocked soon.',
    year: '2025',
    slug: 'luxury-retail-service',
    image: 'linear-gradient(135deg, rgba(255, 214, 153, 0.9), rgba(255, 234, 201, 0.7))',
    accent: '#ffb65e',
    heroBackground: '#ffffff',
    industry: 'Coming Soon',
    services: ['Coming Soon'],
    info: 'This project will be documented shortly with full context, metrics, and outcomes.',
    locked: true
  },
];

export const getProjectBySlug = (slug) => projectsData.find((project) => project.slug === slug);
